export { default } from '@/components/pages/Profile/Profile.container'
